import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "mention",
  class: "mention"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcUserBubble = _resolveComponent("NcUserBubble")

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    ($data.size)
      ? (_openBlock(), _createBlock(_component_NcUserBubble, {
          key: $setup.isDarkTheme ? 'dark' : 'light',
          "display-name": $props.name,
          "avatar-image": $options.avatarUrl,
          user: $props.id,
          size: $data.size,
          primary: $options.primary
        }, null, 8, ["display-name", "avatar-image", "user", "size", "primary"]))
      : _createCommentVNode("", true)
  ], 512))
}